require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-greatest-common-divisor.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-greatest-common-divisor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-greatest-common-divisor!./.cache/json/coding-interview-prep-rosetta-code-greatest-common-divisor.json
// module id = 1892
// module chunks = 231608221292675